exports.APIS = {
  Auth: "/common/auth/admin-login",
  ChangePassword: "/common/auth/change-password",

  Masters: {
    Manage_Admin: "/admin/masters/manage_admin",
    Category: "/admin/masters/catergory",
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    essential_document: "/admin/masters/essential-documents",
    ambassador_reasons: "/admin/masters/ambassador-reasons",
    Ambassador: "/admin/masters/manage_ambassador",
    Ambassador_Wallet: "/admin/masters/manage-ambassador-wallet",
    ServiceCenter: "/admin/masters/service_center",
    TimeSlots: "/admin/masters/time-slots",
    VehicleType: "/admin/masters/vehicle-type",
    VehicleTypeCategory: "/admin/masters/vehicle-type-category",
  },

  UserManagement: {
    Roles: "/admin/employee-management/role",
  },

  superAdmin: {
    admin: "/admin/manage-admin",
  },

  TripLocation: {
    locations: "/admin/trip-location",
  },

  BroadcastNotification: {
    notification: "/admin/masters/broadcast-notification",
    notification_history: "/admin/masters/broadcast-notification-history",
  },

  ManagePickupDropAdmin: {
    NewEntry: "/admin/manage-pickup-drop-admin/new-entry",
    AssignedEntry: "/admin/manage-pickup-drop-admin/assigned-entry",
    CompletedEntry: "/admin/manage-pickup-drop-admin/completed-entry",
    CancelledEntry: "/admin/manage-pickup-drop-admin/cancelled-entry",
    AmbassadorRejectedEntry:
      "/admin/manage-pickup-drop-admin/ambassador-rejected-entry",
  },

  HelpSection: {
    AboutUs: "/admin/help-section/about-us",
    TermsAndConditions: "/admin/help-section/terms-conditiion",
    ServiceTermsAndConditions: "/admin/help-section/service-terms-condition",
    PrivacyPolicy: "/admin/help-section/privacy-policy",
    Faqs: "/admin/help-section/faq",
  },

  Settings: {
    AppSetup: "/admin/settings",
  },

  Dashboard: {
    dashboard: "/admin/admin-dashboard",
  },

  ManageWallet: {
    getAllUsers: "/admin/manage-wallet",
    addAmount: "/admin/manage-wallet/add-amount",
    reduceAmount: "/admin/manage-wallet/reduce-amount",
  },

  ManageReport: {
    getAllManageReports: "/admin/manage-reports",
    getAllManageAmbassadorReports: "/admin/manage-ambassador-reports",
    getAllManageAmbassadorRejectedTrips: "/admin/manage-rejected-trip-reports",
  },

  ManageServiceInvoice: {
    getAllManageServiceInvoice: "/admin/service-invoice",
    getAllManageAmbassadorInvoice: "/admin/ambassador-invoice",
  },

  ManageWalletHIstory: {
    getAllWalletHistory: "/admin/manage-wallet-history",
  },

  ManageWithdrawRequest: {
    getAllWithdrawRequest: "/admin/withdraw-request",
  },

  Commons: {
    AllCountry: "/common/master/all-countries",
    AllState: "/common/master/all-states",
    AllCity: "/common/master/all-cities",
    Cities: "/common/master/all-cities",
    AllPincode: "/common/master/all-pincodes",
    AllAccountStatus: "/common/master/all-account-status",
    AllRoles: "/common/master/all-roles",
    AllPermmission: "/common/master/all-permission",
    AllVerificationStatus: "/common/master/all-verification-status",
    AllCategory: "/common/master/all-category",
    AllServiceCenter: "/common/master/all-service-center",
    AllAmbassadorNew: "/common/master/all-ambassador-new",
    AllVehicleType: "/common/master/all-vehicle-type",
    AllVehicleCategory: "/common/master/all-vehicle-type-category",
    AllAmbassador: "/common/master/all-ambassador",
    AllTimeSlots: "/common/master/all-time-slots",
    AllTimeSlotsAdmin: "/common/master/all-time-slots-admin",
    AllUserStatus: "/common/master/all-user-status",
    AllWithdrawStatus: "/common/master/all-withdraw-status",
    AllTransactionType: "/common/master/all-transaction-type",
    AllType: "/common/master/all-types",
    AllServiceType: "/common/master/all-service-type",
  },

  OTP: {
    send_otp: "/common/otp/otp-send",
    verify_otp: "/common/otp/verify-otp",
  },
};
